import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
    return (
        <section className="hero">
            <div className="hero-content">
                <h1>Tame Your Inbox with MailMeld</h1>
                <p>Get a smart daily summary of your important emails, beautifully categorized and delivered to you. Never miss what matters.</p>
                <a href="YOUR_GOOGLE_WORKSPACE_MARKETPLACE_LINK_HERE" className="cta-button">
                    <span>Install MailMeld</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" style={{ marginLeft: '8px' }}>
                        <path fillRule="evenodd" d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5z" />
                        <path fillRule="evenodd" d="M7.646 9.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8 10.707 5.354 13.354a.5.5 0 0 1-.708-.708l3-3z" />
                    </svg>
                </a>
            </div>
            <div className="email-preview">
                <div className="mockup-container">
                    <div className="mockup-header">
                        <h3>Your Daily Email Summary</h3>
                        <span className="date">May 20, 2025</span>
                    </div>
                    <div className="mockup-content">
                        <div className="category">
                            <h4>Follow-ups (3)</h4>
                            <ul>
                                <li>Project Update Meeting - Response needed</li>
                                <li>Client Proposal Review</li>
                                <li>Team Sync Discussion Points</li>
                            </ul>
                        </div>
                        <div className="category">
                            <h4>Payment Reminders (2)</h4>
                            <ul>
                                <li>Monthly Service Subscription</li>
                                <li>Project Milestone Payment</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;